/*jshint esversion: 6 */
const state = {
  bookings: [],
};

const mutations = {
  loadBookings(state, bookings) {

    bookings.sort(function(a, b) {
      return a.date - b.date || a.timeStart - b.timeStart;
    });

    state.bookings = bookings.reverse();
  },
};

const actions = { 
  loadBookings (context, { vm }) {
    const db = vm.$firebase.firestore();
    const bookings = [];
    var  horse = [];
    var  user = [];
    var  res = [];        
    db.collection("bookings").orderBy("date", "desc").orderBy('timeStart').limit(100).onSnapshot(snapshot => {
      let changes = snapshot.docChanges();
      changes.forEach (change => {
        if (change.type == 'added') {
          var horses;
          var users;
          var resources;
          //get horse          
          horses = vm.$store.getters.horses;
          //get user
          users = vm.$store.getters.users;
          //get booking
          resources = vm.$store.getters.resources;

          horse = horses.find( function (horsex) {
            if (horsex.id.localeCompare(change.doc.data().horseid) === 0){ 
               return true;
            }
            else{              
              return false;
            }
          });
          if (typeof horse === 'undefined')
            horse = {name: 'Ikke fundet'};

          user = users.find( function (userx) {
            if (userx.id.localeCompare(change.doc.data().userid) === 0){ 
               return true;
            }
            else{              
              return false;
            }
          });
          if (typeof user === 'undefined')
          user = {name: 'Ikke fundet'};            

          res = resources.find( function (resx) {
            if (resx.id.localeCompare(change.doc.data().resid) === 0){ 
              return true;
            }
            else{              
              return false;
            }
          });
          if (typeof res === 'undefined')
          res = {name: 'Ikke fundet'} ;

          bookings.push({
            id: change.doc.id,
            date: change.doc.data().date,
            timeEnd: change.doc.data().timeEnd,
            timeStart: change.doc.data().timeStart,          
            horseid: change.doc.data().horseid,
            userid: change.doc.data().userid,
            resid: change.doc.data().resid,
            horseName: horse.name,
            userName: user.name,
            resName: res.name,     
            time: change.doc.data().timeStart + '-' + change.doc.data().timeEnd  
          });        
        }
      });  
      context.commit('loadBookings', bookings);  
      console.log("#loadBookings done#", new Date().getHours(), new Date().getMinutes(), new Date().getSeconds() );    
    });
    
  },
  addNewBooking(context,props) {
    const db = props.vm.$firebase.firestore();
    let problem = false;
    props.vm.$store.dispatch('setMessage', '');
    props.vm.$store.dispatch('setShowAlertBooking', false);
    const booking = {
      date: props.booking.date,
      horseid: props.booking.horseid,
      resid: props.booking.resid,
      timeStart: props.booking.timeStart,
      timeEnd: props.booking.timeEnd,
      userid: props.booking.userid
    };

    // har allerede en ikke afsluttet reservation for den valgte hest.
    if (state.bookings.filter(booking => { return booking.horseid === props.booking.horseid && booking.date === props.vm.$store.getters.dateSelected; }).length > 0){
      props.vm.$store.dispatch('setMessage', 'Du har allerede en reservation for den valgte hest på den valgte dag!. Det er kun muligt at have en reservation per dag. Du kan slette reservationer på Min side');
      props.vm.$store.dispatch('setShowAlertBooking', true);        
      problem = true;

    }    

    //check om dobbelt      
    if (state.bookings.filter(booking => { return booking.resid === props.booking.resid && booking.date === props.booking.date && props.booking.timeStart < booking.timeEnd && props.booking.timeEnd > booking.timeStart; }).length > 0){
      props.vm.$store.dispatch('setMessage', 'Folden er reserveret på det valgte tidspunkt!');
      props.vm.$store.dispatch('setShowAlertBooking', true);       
      problem = true;

    }
    if (props.booking.timeStart >= props.booking.timeEnd){
      props.vm.$store.dispatch('setMessage', 'Starttid skal være større end sluttid!');
      props.vm.$store.dispatch('setShowAlertBooking', true);      
      problem = true;
    }  
    if (props.booking.timeStart === '' || props.booking.timeEnd === '' || props.booking.date === ''){
      props.vm.$store.dispatch('setMessage', 'Vælg et tidspunkt!');
      props.vm.$store.dispatch('setShowAlertBooking', true);       
      problem = true;
    } 
    if (props.booking.horseid === '' ){      
      props.vm.$store.dispatch('setMessage', 'Vælg en hest');
      props.vm.$store.dispatch('setShowAlertBooking', true);

      problem = true;
    }
    if (problem !== true){
      db.collection('bookings').add(booking).then( (docRef) => {
        booking.id = docRef.id;
        //props.vm.$store.dispatch('writeLog',{userid: props.profile.id, username: props.profile.name , message: 'Booking added: ' + docRef.id, vm: props.vm})
        props.vm.$store.dispatch('setAddBookingDialog', false);
        //context.commit('addNewBooking')
      })  
      .catch(err => {
        props.vm.$store.dispatch('setMessage', err.message);
        props.vm.$store.dispatch('setShowAlertBooking', true);
      });    
    }
    else
      props.vm.$store.dispatch('setAddBookingDialog', true);

  },      
};

const getters = {
  bookings: state => {
    return state.bookings;
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};
 